module.exports = __webpack_public_path__ + "static/media/PB.73f10219.jpg";